export default __webpack_public_path__ + "static/media/icons8-bookmark-96.dc95290c.svg";